import { FC, Fragment, ReactNode } from 'react';
import { mainContainerVariants, menuContainerVariants, overlayVariants } from './SubMenuMobile.animate';
import { BackIcon, CloseIcon, Container, MenuHeading, MenuTitle, WrapperOverlay } from './SubMenuMobile.style';
interface Props {
  isSubMenuMobileOpen: boolean;
  setIsSubMenuMobileOpen: (val: boolean) => void;
  onCloseMenu: () => void;
  title: string;
  content: ReactNode;
}
const SubMenuMobile: FC<Props> = ({
  isSubMenuMobileOpen,
  setIsSubMenuMobileOpen,
  onCloseMenu,
  title,
  content
}: Props) => {
  return <Fragment>
            <Container initial="closed" variants={mainContainerVariants} animate={isSubMenuMobileOpen ? 'open' : 'closed'}>
                <MenuHeading variants={menuContainerVariants}>
                    <MenuTitle onClick={() => setIsSubMenuMobileOpen(false)}>
                        <BackIcon src="/icons/arrow-left-gray.svg" alt="back" width={8} height={36} />
                        {title}
                    </MenuTitle>
                    <CloseIcon src="/icons/x.svg" alt="close" onClick={onCloseMenu} width={18} height={18} />
                </MenuHeading>
                {content}
            </Container>
            {isSubMenuMobileOpen && <WrapperOverlay variants={overlayVariants} animate={isSubMenuMobileOpen ? 'open' : 'closed'} onClick={onCloseMenu} />}
        </Fragment>;
};
export default SubMenuMobile;